import {urlApi, path} from '../values';
const url = urlApi + path

export const sendMessage = async(name, email, message) =>{
    const obj = {
        Name:       name,
        Email:      email,
        Message:    message
    }
    console.log("URL: ", url);
    const request = {
        method:"POST",
        body: JSON.stringify(obj),
        headers:{
            // 'Authorization': bearer,
            'Content-Type': 'application/json'
        }
    }
    const res = await fetch(url, request)
    .then((res) =>{
        if(res.status === 200){
            console.log(res.status);
            return true
        } else{
            return false
        }
    })
    .catch(() =>{
        return false
    })
    return res
}